export default "__VITE_ASSET__CGJng1Jn__"